<template>
  <div>
    <b-sidebar
      width="60%"
      id="task-datail"
      right
      backdrop
      shadow
      @hidden="hidden"
    >
      <b-row class="p-2">
        <b-col md="12">
          <b-card :title="$t('user.attached_files')">
            <Files
              :object_id="GET_PTO_FOR_GOOD_ONE.id || 0"
              @refresh="refresh"
            />
          </b-card>

          <b-card :title="$t('contact.comment')">
            <b-row>
              <b-col md="12" class="mt-2">
                <div class="d-flex justify-content-end"></div>
                <Comments
                  :object_id="GET_PTO_FOR_GOOD_ONE.id || 0"
                  @refresh="refresh"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-sidebar>
    
    <UploadFileModal />
  </div>
</template>

<script>
import {
  BImg,
  BButton,
  BSidebar,
  VBToggle,
  BRow,
  BFormGroup,
  BCol,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BListGroup,
  BListGroupItem,
  BCardText,
  BCard,
  BBadge,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BFormFile,
  BAvatarGroup,
  BAvatar,
  VBTooltip,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { quillEditor } from "vue-quill-editor";
import Ripple from "vue-ripple-directive";
import Comments from "../../components/Comments/index.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import UploadFileModal from "./UploadFileModal.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Files from "../../components/Files";
import moment from "moment";

export default {
  props: ["task", "loading"],
  data() {
    return {
      titleToggle: false,
      descriptionToggle: false,
    };
  },

  methods: {
    refresh() {
      this.$emit("refresh");
    },

    hidden() {
      this.titleToggle = false;
      this.descriptionToggle = false;
    },
  },

  computed: {
    ...mapGetters("pto", ["GET_PTO_FOR_GOOD_ONE"]),
  },

  destroyed() {
    document.removeEventListener("paste", this.previewFile);
  },

  components: {
    BImg,
    BButton,
    BSidebar,
    BRow,
    BCol,
    BFormGroup,
    BFormTextarea,
    BCardText,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BDropdown,
    BDropdownItem,
    BListGroup,
    BListGroupItem,
    BFormFile,
    Comment,
    quillEditor,
    FeatherIcon,
    Comments,
    Files,
    // UploadFiles,
    BAvatarGroup,
    BAvatar,

    AppTimelineItem,
    AppTimeline,
    // PhotoPreviewer,
    UploadFileModal,
  },
  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
    ripple: Ripple,
  },
};
</script>

<style>
.dark-layout #task-datail {
  background-color: #151c30 !important;
}

.img-box img {
  width: 100%;
}

.r08 {
  font-size: 0.8rem;
}
</style>
